import type {
  InventoryStockLocationRecord,
  InventoryUnitRecord,
} from '@/renderer/types/inventory';
import { useInventoryItemSelectOptions } from '@hooks/inventory';
import { createContext, useContext } from 'react';
import type { FormState, LineForm } from './stockTransferFormUtils';

export interface StockTransferFormContextValue {
  locations: InventoryStockLocationRecord[];
  units: InventoryUnitRecord[];
  isSaving: boolean;
  onClose: () => void;
  uid: string;
  form: FormState;
  setFormField: <K extends keyof Omit<FormState, 'lines'>>(
    field: K,
    value: FormState[K],
  ) => void;
  setLine: (
    key: string,
    field: keyof Omit<LineForm, 'key'>,
    value: string,
  ) => void;
  addLine: () => void;
  removeLine: (key: string) => void;
  itemOptions: ReturnType<typeof useInventoryItemSelectOptions>;
  balanceByItemId: Map<string, number>;
  isBalancesFetching: boolean;
  isBalancesLoading: boolean;
  hasAnyInvalidQuantity: boolean;
  hasAnyOverAvailable: boolean;
  canSubmit: boolean;
  handleSubmit: () => void;
}

export const StockTransferFormContext =
  createContext<StockTransferFormContextValue | null>(null);

export const useStockTransferFormContext = () => {
  const context = useContext(StockTransferFormContext);
  if (!context) {
    throw new Error(
      'useStockTransferFormContext must be used within StockTransferEditorModal',
    );
  }
  return context;
};
